import { fetchForms } from './fetch-forms';
import { loadTranslations, } from '../../services/load-translations';
import { getUserData } from './wix-code-api';
import { getLocaleDataset, getAddressTemplates, getFieldInitialData, } from './load-forms';
export const getInitialData = async ({ formIds, formKind, namespace, throwWhenFormMissing, locale, localeDatasetLoader, httpClient, errorMonitor, additionalMetadata, wixCodeApi, errorHandler, environment, bi, }) => {
    const [formsById, translations, userData] = await Promise.all([
        fetchForms({
            formIds,
            formKind,
            namespace,
            httpClient,
            errorMonitor,
            throwWhenFormMissing,
            additionalMetadata,
            errorHandler,
            locale,
        }),
        loadTranslations(locale, errorMonitor),
        getUserData(wixCodeApi),
    ]);
    const forms = Object.values(formsById).filter(Boolean);
    const [localeDataset, addressTemplates, fieldInitialData] = await Promise.all([
        getLocaleDataset({
            allForms: forms,
            locale,
            localeDatasetLoader,
            errorMonitor,
        }),
        getAddressTemplates({
            forms,
            existingAddressTemplates: undefined,
            httpClient,
            errorHandler,
            excludeEcomAddress: true,
        }),
        getFieldInitialData({
            forms,
            httpClient,
            errorHandler,
            wixCodeApi,
            environment,
            bi,
        }),
    ]);
    return {
        formsById,
        translations,
        localeDataset,
        addressTemplates,
        fieldInitialData,
        userData,
    };
};
//# sourceMappingURL=get-initial-data.js.map